<template>
  <div class="contract-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenTopBtn">
      <template v-slot:buttons>
        <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          class="vxe-btn-delete"
          @click="deleteBtnClickHandler()"
          >删除</el-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      keep-source
      border
      size="mini"
      align="left"
      show-overflow
      show-header-overflow
      ref="xTableRef"
      class="vxe-table-element"
      resizable
      show-footer
      :auto-resize="true"
      :data="tableData"
      :footer-method="footerMethod"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-rules="tableRule"
      height="300"
      :edit-config="editConfig"
      @edit-closed="closeEditTableHandler"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" fixed="left" width="50"></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="80"></vxe-table-column>
      <vxe-table-column type="seq" title="行项目号" width="100"></vxe-table-column>
      <template v-for="(item, index) of computedPurchaseAgreementColumns">
        <!-- 表头嵌套 -->
        <template v-if="item.children && item.children.length">
          <vxe-table-column :key="index" :title="item.title" align="center">
            <vxe-table-column
              v-for="(child, index1) of item.children"
              :key="index1"
              :field="child.field"
              :width="child.width"
              :edit-render="child.editRender"
              :title="child.title"
              :visible="child.visible"
              :disabled="child.disabled"
            >
              <template v-slot="{ row }">
                <template v-if="child.field == 'isFixedPrice'">
                  <span>{{ row[child.field] == '0' ? '否' : '是' }}</span>
                </template>
                <template v-else-if="child.field == 'businessChangeUnitPrice'">
                  <span v-if="row[child.field]">{{ replaceLastZeroStr(row[child.field]) }}</span>
                  <span v-else>&nbsp;</span>
                  <i
                    v-if="isShowVariablePriceIcon && row['isFixedPrice'] == '0'"
                    class="el-icon-edit-outline icon-btn"
                    @click.stop="(val) => clickBusinessOpenDialog(val, row, child.field)"
                  ></i>
                </template>
                <template
                  v-else-if="
                    [
                      'businessContractUnitPrice',
                      'productQuantity',
                      'businessChangeTaxAmount',
                      'variablePrice',
                      'businessChangeUnitPrice',
                      'businessChangeTaxAmount',
                      'businessContractTaxAmount',
                    ].includes(child.field)
                  "
                >
                  {{ replaceLastZeroStr(row[child.field]) }}
                </template>
                <template
                  v-else-if="
                    ['businessChangeTotalAmount', 'businessContractTotalAmount'].includes(
                      child.field
                    )
                  "
                >
                  {{ replaceZeroStr(row[child.field]) }}
                </template>
                <span v-else>{{ row[child.field] }}</span>
              </template>
              <template v-slot:edit="{ row }">
                <!-- 合同价格 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessContractUnitPrice'"
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                  :disabled="currentDisabledFiledList.includes('businessContractUnitPrice')"
                ></InputNumberAd>
                <!-- 价税合计金额 -->
                <el-input
                  v-if="child.editRender?.name == 'businessContractTotalAmount'"
                  disabled
                  v-model="row[child.field]"
                  @input="() => handleChange(row, child.field)"
                />
                <!-- 税额 -->
                <el-input
                  v-if="child.editRender?.name == 'businessContractTaxAmount'"
                  v-model="row[child.field]"
                  disabled
                  @input="() => handleChange(row, child.field)"
                />
                <!-- 净值 -->
                <!-- <el-input
                  v-if="child.editRender?.name == 'businessChangePureAmount'"
                  v-model="row[child.field]"
                  disabled
                  @input="() => handleChange(row, child.field)"
                /> -->
                <!-- 价税合计金额 -->
                <el-input
                  v-if="child.editRender?.name == 'businessChangeTotalAmount'"
                  v-model="row[child.field]"
                  disabled
                  @input="() => handleChange(row, child.field)"
                />
                <!-- 税额 -->
                <el-input
                  v-if="child.editRender?.name == 'businessChangeTaxAmount'"
                  v-model="row[child.field]"
                  disabled
                  @input="() => handleChange(row, child.field)"
                />
                <!-- 变动后合同含税单价 需要判断 -->
                <InputNumberAd
                  :controls="false"
                  class="inputWidth"
                  :precision="6"
                  max="99999999999"
                  v-if="child.editRender?.name == 'businessChangeUnitPrice'"
                  v-model="row[child.field]"
                  :disabled="
                    currentDisabledFiledList.includes('businessContractUnitPrice') ||
                    disabledBusinessChangeUnitPrice
                  "
                  @input="() => handleChange(row, child.field)"
                ></InputNumberAd>
              </template>
            </vxe-table-column>
          </vxe-table-column>
        </template>
        <!-- 正常列 -->
        <template v-else>
          <vxe-table-column
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.field"
            :title="item.title"
            :width="item.width"
            :visible="item.visible"
            :sortable="item.sortable"
            :edit-render="item.editRender"
            :disabled="item.disabled"
          >
            <template v-slot="{ row }">
              <template v-if="item.field == 'variablePrice'">
                <span v-if="row[item.field]">{{ row[item.field] }}</span>
                <span v-else>&nbsp;</span>
                <i
                  v-if="isShowVariablePriceIcon && row['isFixedPrice'] == '0'"
                  class="el-icon-edit-outline icon-btn"
                  @click.stop="(val) => clickBusinessOpenDialog(val, row, item.field)"
                ></i>
              </template>
              <template v-else-if="item.field == 'productDesc' && isShowVariablePriceIcon">
                <span>{{ row[item.field] }}</span>
                <i
                  v-if="isShowVariablePriceIcon && row['isFixedPrice'] == '0'"
                  class="el-icon-chat-square icon-btn"
                  @click.stop="(val) => clickProductDescOpenDialog(val, row, item.field)"
                ></i>
              </template>
              <template v-else-if="item.field == 'isFixedPrice'">
                <span>{{ row[item.field] == '0' ? '否' : '是' }}</span>
              </template>
              <template v-else-if="item.field == 'priceConfirmDate'">
                <span>{{ row[item.field] | dateFormat }}</span>
              </template>
              <template v-else-if="item.field == 'materialType'">
                <span>{{ materialTypeStr(row[item.field]) }}</span>
              </template>
              <template v-else-if="item.field == 'unit'">
                <span>{{ row['unitName'] }}</span>
              </template>
              <template v-else-if="item.field == 'priceIdentity'">
                <template v-if="row[item.field] == '0'">未定价</template>
                <template v-else>已定价</template>
              </template>
              <template
                v-else-if="
                  [
                    'businessContractUnitPrice',
                    'productQuantity',
                    'businessChangeTaxAmount',
                    'variablePrice',
                    'businessChangeUnitPrice',
                    'businessChangeTaxAmount',
                    'businessContractTaxAmount',
                  ].includes(item.field)
                "
              >
                {{ replaceLastZeroStr(row[item.field]) }}
              </template>
              <template
                v-else-if="
                  ['businessChangeTotalAmount', 'businessContractTotalAmount'].includes(item.field)
                "
              >
                {{ replaceZeroStr(row[item.field]) }}
              </template>
              <span v-else>{{ row[item.field] }}</span>
            </template>
            <template v-slot:edit="{ row }">
              <!-- 商品 -->
              <search-table
                v-if="item.editRender?.name == 'productDesc'"
                v-model="row[item.field]"
                searchType="product"
                :isMultiple="true"
                :extraData="{
                  detailProductStatus: 'ZT03',
                  contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
                  adminFlag: 2,
                  selectCompanyCode: baseFormData.companyCode,
                }"
                :currentValue="row[item.field]"
                @input="(val) => chooseTable(val, row, item.field)"
                :disabled="currentDisabledFiledList.includes('productDesc')"
              ></search-table>
              <!-- 料型 -->
              <el-select
                v-if="item.editRender?.name == 'materialType'"
                :disabled="currentDisabledFiledList.includes('materialType')"
                v-model="row[item.field]"
              >
                <el-option
                  v-for="(item, index) of materialTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="index"
                ></el-option>
              </el-select>
              <!-- 增值税 -->
              <el-input
                v-if="item.editRender?.name == 'taxRate'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              />
              <!-- 是否定价 -->
              <el-select
                v-if="item.editRender?.name == 'isFixedPrice'"
                filterable
                clearable
                v-model="row[item.field]"
                @change="() => handleChange(row, item.field)"
                :disabled="currentDisabledFiledList.includes('isFixedPrice')"
              >
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
              <!-- 合同价格 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'businessContractUnitPrice'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
                :disabled="currentDisabledFiledList.includes('businessContractUnitPrice')"
              ></InputNumberAd>
              <!-- 仓库 -->

              <search-table
                v-if="item.editRender?.name == 'storageName'"
                v-model="row[item.field]"
                searchType="warehouse"
                :isMultiple="true"
                :disabled="currentDisabledFiledList.includes('storageName')"
                :extraData="{
                  currentStatus: 'ZT03',
                  contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
                  adminFlag: 2,
                  selectCompanyCode: baseFormData.companyCode,
                  storageDepartmentCode: baseFormData.departmentCode,
                }"
                :currentValue="row[item.field]"
                @input="(val) => chooseTable(val, row, item.field)"
              ></search-table>
              <!-- 价格标识 -->
              <span v-if="item.editRender?.name == 'priceIdentity'">
                <template v-if="row[item.field] == '0'">未定价</template>
                <template v-else>已定价</template>
              </span>
              <!-- <el-input
                v-if="item.editRender?.name == 'priceIdentity'"
                v-model="row[item.field]"
                disabled
                @input="() => handleChange(row, item.field)"
              /> -->
              <!-- 单位 -->
              <el-input
                v-if="item.editRender?.name == 'unit'"
                v-model="row.unitName"
                disabled
                @input="() => handleChange(row, item.field)"
              />
              <!-- 变动后合同含税单价 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                :disabled="currentDisabledFiledList.includes('businessChangeUnitPrice')"
                v-if="item.editRender?.name == 'businessChangeUnitPrice'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 变动单价 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'variablePrice'"
                v-model="row[item.field]"
                disabled
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 价格确定时间 -->
              <el-date-picker
                v-if="item.editRender?.name == 'priceConfirmDate'"
                format="yyyy-MM-dd"
                v-model="row[item.field]"
                style="width: 100%"
                disabled
                @input="() => handleChange(row, item.field)"
              ></el-date-picker>
              <!-- 目的地 -->
              <el-input
                v-if="item.editRender?.name == 'destination'"
                v-model="row[item.field]"
                :disabled="currentDisabledFiledList.includes('destination')"
                @input="() => handleChange(row, item.field)"
              />
              <!-- 起运地 -->
              <el-input
                v-if="item.editRender?.name == 'shipmentPlace'"
                v-model="row[item.field]"
                :disabled="currentDisabledFiledList.includes('shipmentPlace')"
                @input="() => handleChange(row, item.field)"
              />
              <!-- 采购数量 -->
              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'productQuantity'"
                v-model="row[item.field]"
                :disabled="currentDisabledFiledList.includes('productQuantity')"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 交货数量 -->

              <InputNumberAd
                :controls="false"
                class="inputWidth"
                :precision="6"
                max="99999999999"
                v-if="item.editRender?.name == 'productQuantity1'"
                v-model="row[item.field]"
                :disabled="currentDisabledFiledList.includes('productQuantity1')"
                @input="() => handleChange(row, item.field)"
              ></InputNumberAd>
              <!-- 销售数量 -->
              <el-input
                v-if="item.editRender?.name == 'productQuantity2'"
                v-model="row[item.field]"
                disabled
                @input="() => handleChange(row, item.field)"
              ></el-input>
            </template>
          </vxe-table-column>
        </template>
      </template>
    </vxe-grid>
    <BusinessDialog ref="businessDialogRef" @updateProduct="updateProduct" />
    <ProductDescDialog ref="productDescDialogRef" />
  </div>
</template>

<script>
  import { purchaseAgreementColumns, tableRule } from './../columns.js';
  import productMixins from './../mixins.js';
  import editTableMixin from './../editTableMixin.js';
  import BusinessDialog from './BusinessDialog.vue';
  import ProductDescDialog from './ProductDescDialog';
  import contractComputedMixin from './../../../contractComputedMixin.js';
  import {
    COMPANY_CODE1,
    COMPANY_CODE2,
    INTERNAL_SETTLEMENT,
    WITHOUT_SETTLEMENT,
    DROP_OFF_PERSON,
  } from '@/constants';
  export default {
    name: 'ContractTable',
    mixins: [productMixins, editTableMixin, contractComputedMixin],
    props: {
      fileType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        computedPurchaseAgreementColumns: [],
        tableRule,
        edit: this.isEdit,
        selectionList: [],
        materialTypeList: [],
        disabledBusinessChangeUnitPrice: true,
      };
    },
    methods: {
      // 点击打开编辑价格弹框
      clickBusinessOpenDialog(val, row, fieldName) {
        console.log(val, row, fieldName);
        this.$refs.businessDialogRef.openModal(
          row,
          this.detailPageData.pricingRule
          // this.detailPageData.overShippedPercentage
        );
      },
      // 详情弹框
      clickProductDescOpenDialog(val, row, fieldName) {
        console.log(val, row, fieldName);
        this.$refs.productDescDialogRef.openModal(row);
      },
      // 表底合并
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '小计';
            }
            if (column.property === 'productQuantity') {
              return this.replaceLastZeroStr(
                data.reduce((prev, cur) => prev + +cur.productQuantity, 0).toFixed(6)
              );
            }
            if (column.property === 'businessContractTotalAmount') {
              return this.replaceZeroStr(
                data.reduce((prev, cur) => prev + +cur.businessContractTotalAmount, 0).toFixed(6)
              );
            }
            if (column.property === 'businessContractTaxAmount') {
              return this.replaceLastZeroStr(
                data.reduce((prev, cur) => prev + +cur.businessContractTaxAmount, 0).toFixed(6)
              );
            }
            return '-';
          }),
        ];
        return footerData;
      },
      filterTableColumn(val) {
        const { isGenerateSales, isRelatedParty, partnerType, companyCode, ifPersonalPartner } =
          val;
        const supplierType = this._judgeSupplierType(
          isRelatedParty,
          partnerType,
          ifPersonalPartner
        );
        console.log(
          supplierType,
          '供应商类型',
          isGenerateSales,
          isRelatedParty,
          partnerType,
          companyCode
        );
        const baseTableColumn = purchaseAgreementColumns(this);
        // 是否公司为城矿公司且是内部结算公司的时候才有根据条件来显示
        if (COMPANY_CODE1.includes(companyCode) && supplierType == INTERNAL_SETTLEMENT) {
          console.log('城矿公司->表格内部结算公司-合同');
          // 内部结算公司
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (
              [
                'contract',
                'taxRate',
                'storageName',
                'productQuantity2',
                'priceIdentity',
                'unit',
                'destination',
                'shipmentPlace',
                'variablePrice',
                'materialType',
                'priceConfirmDate',
                'isFixedPrice',
              ].includes(item.field)
            ) {
              return {
                ...item,
                visible: true,
                width: 160,
                children:
                  item?.children && Array.isArray(item?.children) && item?.children.length
                    ? item?.children?.map((it) => {
                        return {
                          ...it,
                          visible: true,
                          width: 160,
                        };
                      })
                    : null,
              };
            } else {
              return {
                ...item,
                width: 160,
              };
            }
          });
          if (isGenerateSales) {
            this._changeTableColumnVisible(true);
          } else {
            this._changeTableColumnVisible(false);
          }
        } else if (COMPANY_CODE1.includes(companyCode) && supplierType == WITHOUT_SETTLEMENT) {
          console.log('城矿公司->表格外部结算合同');
          // 外部结算协议的时候
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (
              [
                'businessContractUnitPrice',
                'businessContractTotalAmount',
                'productQuantity1',
                'productQuantity2',
                'variablePrice',
                'businessChangeUnitPrice',
                'shipmentPlace',
                'destination',
                'materialType',
              ].includes(item.field)
            ) {
              return {
                ...item,
                visible: false,
              };
            } else {
              return {
                ...item,
                visible: true,
                width: 160,
                children:
                  item?.children && Array.isArray(item?.children) && item?.children.length
                    ? item?.children?.map((it) => {
                        return {
                          ...it,
                          visible: true,
                          width: 160,
                        };
                      })
                    : null,
              };
            }
          });
        } else if (COMPANY_CODE2.includes(companyCode) && supplierType == DROP_OFF_PERSON) {
          console.log('demo公司->表格合同投送人');
          // 投送公司合同
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (['contract', 'taxRate', 'storageName'].includes(item.field)) {
              return {
                ...item,
                visible: true,
                width: 160,
                children:
                  item?.children && Array.isArray(item?.children) && item?.children.length
                    ? item?.children?.map((it) => {
                        return {
                          ...it,
                          visible: true,
                          width: 160,
                        };
                      })
                    : null,
              };
            } else {
              return {
                ...item,
                width: 160,
              };
            }
          });
        } else {
          console.log('走表格默认');
          this.computedPurchaseAgreementColumns = baseTableColumn.map((item) => {
            if (['isFixedPrice'].includes(item.field)) {
              return {
                ...item,
                visible: false,
              };
            }
            if (['contract', 'taxRate', 'storageName'].includes(item.field)) {
              return {
                ...item,
                visible: true,
                width: 160,
                children:
                  item?.children && Array.isArray(item?.children) && item?.children.length
                    ? item?.children?.map((it) => {
                        return {
                          ...it,
                          visible: true,
                          width: 160,
                        };
                      })
                    : null,
              };
            } else {
              return {
                ...item,
                width: 160,
              };
            }
          });
        }
        // 刷新列
        this.$nextTick(() => {
          this.$refs.xTableRef.refreshColumn();
        });
      },
      // 刷新表格数据
      updateProduct(obj) {
        console.log(obj, '更新');
        if (obj.prop == 'priceChange') {
          let row = obj.val;
          const productList = this.$refs.xTableRef.getTableData().fullData;
          productList.map((item) => {
            if (item.id == row.id) {
              item.businessChangeUnitPrice = row.businessChangeUnitPrice;
              item.priceConfirmDate = row.priceConfirmDate;
              item.priceIdentity = row.priceIdentity;
              item.businessChangeTaxAmount = row.businessContractTaxAmount;
              item.version = row.version;
              item.isPricingRecord = row.isPricingRecord;
              item.avgUnitPrice = row.avgUnitPrice;
              item.variablePrice = row.temporaryPrice;
              // 调用变动单价计算
              item['businessChangeTotalAmount'] = this.computedBusinessChangeTotalAmount(row); // 变动单价中 - 价税合计金额
              // item['businessChangePureAmount'] = this.computedBusinessChangePureAmount(row); // 变动单价中 - 净值
              item['businessChangeTaxAmount'] = this.computedBusinessChangeTaxAmount(row); // 变动单价中 - 税额
              item['businessChangePureAmount'] =
                item['businessChangeTotalAmount'] - item['businessChangeTaxAmount'] + ''; // 变动单价中 - 净值
            }
          });
          // 更新表格数据
          this.$refs.xTableRef.reloadData(productList);
        }
      },
      // 关闭的时候数据校验
      closeEditTableHandler() {
        console.log(this.getTableData(), '???');
        // const $table = this.$refs.xTableRef;
        // const errMap = await $table.validate().catch((errMap) => errMap);
        // if (errMap) {
        //   this.$message.error('请检查数据再提交');
        // } else {
        //   await $table.clearActived();
        //   // 派发事件更新表单数据
        //   this.$emit('closeTableHandler', this.getTableData());
        // }
        this.$emit('closeTableHandler', this.getTableData());
      },
      _changeTableColumnVisible(isVisible) {
        console.log('内部特殊处理', isVisible);
        this.computedPurchaseAgreementColumns = this.computedPurchaseAgreementColumns.map(
          (item) => {
            if (
              [
                'isFixedPrice',
                'materialType',
                'productQuantity2',
                'priceConfirmDate',
                'priceIdentity',
                'variablePrice',
                'shipmentPlace',
                'destination',
              ].includes(item.field)
            ) {
              return {
                ...item,
                visible: isVisible,
                width: 160,
              };
            } else {
              return {
                ...item,
              };
            }
          }
        );
      },
      // 单独处理料型
      materialTypeStr(item) {
        return this.materialTypeList.find((it) => it.value == item)?.label;
      },
    },
    mounted() {
      // 料型下拉框
      this.materialTypeList = this.dictListMap.materialType;
    },
    components: {
      BusinessDialog,
      ProductDescDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .contract-table {
    ::v-deep {
      .vxe-body--column .vxe-cell {
        position: relative;
      }
    }
    .icon-btn {
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      top: 5px;
      right: 6px;
      color: rgb(98, 153, 254);
    }
  }
</style>
